<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="stretch-to-parent">
    <div class="relate-to-parent row" style="margin: 0">
        <div class="col-3 p-0">
            <winde-customer-accordion [badgeAttribute]="customersBadgeAttribute" [baseUrl]="baseUrl"></winde-customer-accordion>
        </div>

        <div class="col-9 p-0">
            <div class="customers-main-box">
                <div class="customers-header">
                    <winde-customer-details [baseUrl]="baseUrl"></winde-customer-details>
                </div>

                <div class="customers-content">
                    @if (selectedCustomerId$ | async) {
                        <div class="relate-to-parent">
                            <router-outlet></router-outlet>
                        </div>
                    } @else {
                        <div class="row justify-content-center mx-auto not-found">
                            <strong><span>{{ 'project.home.customersNotFound' | translate }}</span></strong>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
